import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';

export type ApprovalDialogMode = 'approve' | 'edit' | null;

interface ApprovalDialogProps {
    mode: ApprovalDialogMode;
    comment: string;
    onCommentChange: (value: string) => void;
    isSubmitting: boolean;
    onCancel: () => void;
    onSubmit: () => void;
}

export default function ApprovalDialog({
    mode,
    comment,
    onCommentChange,
    isSubmitting,
    onCancel,
    onSubmit,
}: ApprovalDialogProps) {
    const { t } = useTranslation();
    const isEdit = mode === 'edit';

    return (
        <Dialog
            open={mode !== null}
            onOpenChange={(open) => {
                if (!open) onCancel();
            }}
        >
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>
                        {isEdit
                            ? t('departmentPolicies.approvalDialog.editTitle')
                            : t(
                                  'departmentPolicies.approvalDialog.approveTitle'
                              )}
                    </DialogTitle>
                    <DialogDescription>
                        {isEdit
                            ? t(
                                  'departmentPolicies.approvalDialog.editDescription'
                              )
                            : t(
                                  'departmentPolicies.approvalDialog.approveDescription'
                              )}
                    </DialogDescription>
                </DialogHeader>
                <textarea
                    placeholder={t(
                        'departmentPolicies.approvalDialog.commentPlaceholder'
                    )}
                    value={comment}
                    onChange={(e) => onCommentChange(e.target.value)}
                    rows={4}
                    className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring resize-none"
                />
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={onCancel}
                        disabled={isSubmitting}
                    >
                        {t('departmentPolicies.approvalDialog.cancel')}
                    </Button>
                    <Button
                        onClick={onSubmit}
                        disabled={isSubmitting}
                        className={
                            isEdit
                                ? undefined
                                : 'bg-approval text-white hover:bg-approval-hover'
                        }
                    >
                        {isEdit
                            ? t(
                                  'departmentPolicies.approvalDialog.saveComment'
                              )
                            : t('departmentPolicies.approvalDialog.approve')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
